module.exports = __webpack_public_path__ + "static/img/ical-icon.83f4eb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/ical-icon.jpg
// module id = 1425
// module chunks = 1